import React from "react";
import { FaLinkedin, FaGithub, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-10 mt-0">
      <div className="max-w-5xl mx-auto text-center">
        
        {/* Name & Brief Intro */}
        <h3 className="text-xl font-bold">Sri Deepthi Vootla</h3>
        <p className="text-gray-400 text-sm mt-2">
        A Data Science graduate with expertise in Data Analysis, Machine Learning, and Cloud Computing.
        </p>

        {/* Social Links */}
        <div className="flex justify-center gap-6 mt-4">
          <a href="https://www.linkedin.com/in/sri-deepthi-vootla" target="_blank" rel="noreferrer">
            <FaLinkedin className="text-2xl text-white hover:text-purple-400 transition-all" />
          </a>
          <a href="https://github.com/srideepthi-vootla" target="_blank" rel="noreferrer">
            <FaGithub className="text-2xl text-white hover:text-purple-400 transition-all" />
          </a>
          <a href="mailto:srideepthivootla1999@gmail.com">
            <FaEnvelope className="text-2xl text-white hover:text-purple-400 transition-all" />
          </a>
        </div>

        {/* Quick Navigation */}
        <div className="flex justify-center gap-6 mt-6 text-sm">
          <a href="#about" className="hover:text-purple-400 transition-all">About</a>
          <a href="#experience" className="hover:text-purple-400 transition-all">Experience</a>
          <a href="#projects" className="hover:text-purple-400 transition-all">Projects</a>
          <a href="#contact" className="hover:text-purple-400 transition-all">Contact</a>
        </div>

        {/* Location & Availability */}
        <div className="mt-4 flex justify-center items-center gap-2 text-gray-400 text-sm">
          <FaMapMarkerAlt className="text-lg text-white" />
          <span>Open to opportunities worldwide</span>
        </div>

        {/* Copyright */}
        <p className="text-gray-500 text-sm mt-6">
          © {new Date().getFullYear()} Sri Deepthi Vootla. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;